/**
 * @generated SignedSource<<16f48dc6fd47abe5f7fdb0c38b0ab3c0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type InvoiceFilterButton_company$data = {
  readonly newXeroEnabled: boolean | null;
  readonly quickbooksEnabled: boolean | null;
  readonly economicEnabled: boolean | null;
  readonly sageIntacctConnectionEnabled: boolean | null;
  readonly " $fragmentType": "InvoiceFilterButton_company";
};
export type InvoiceFilterButton_company$key = {
  readonly " $data"?: InvoiceFilterButton_company$data;
  readonly " $fragmentSpreads": FragmentRefs<"InvoiceFilterButton_company">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "InvoiceFilterButton_company",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "newXeroEnabled",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "quickbooksEnabled",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "economicEnabled",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "sageIntacctConnectionEnabled",
      "storageKey": null
    }
  ],
  "type": "Company",
  "abstractKey": null
};

(node as any).hash = "aa2fa81b03e161b1e94ebdb8e3bad6bf";

export default node;
